import type { GetterTree, Store } from "vuex";
import type { State } from "@/store/state";
import type { MapState } from "./state";
import type { GISLayerBase, MapboxLayersFixed } from "@/interfaces/gis_layer";

export const getters: GetterTree<MapState, State> = {
  mapZoom: (state): number => state.zoom,
  center: (state): { lat: number; lng: number } => state.center,
  gisLayers: (state): GISLayerBase[] => state.GISLayers,
  mapboxGeoJSONLayers: (state): Partial<MapboxLayersFixed>[] => {
    return state.GISLayers.map((layer): Partial<MapboxLayersFixed> => {
      const type = ["circle", "line", "fill", "symbol", "raster"].includes(
        layer.layer_type,
      )
        ? layer.layer_type
        : "circle";
      return {
        sourcetype: "geojson",
        source: layer.geojson,
        type: type as "circle" | "line" | "fill" | "symbol" | "raster",
        below: "traces",
        color: layer.color,
        circle: { radius: layer.layer_type === "point" ? 4 : 0 },
      };
    });
  },
};

const NS = "map/";

export const readMapZoom = (store: Store<State>) =>
  store.getters[`${NS}mapZoom`] as number;
export const readMapCenter = (store: Store<State>) =>
  store.getters[`${NS}center`] as { lat: number; lng: number };
export const readGISLayers = (store: Store<State>) =>
  store.getters[`${NS}gisLayers`] as GISLayerBase[];
export const readMapBoxGeoJSONLayers = (store: Store<State>) =>
  store.getters[`${NS}mapboxGeoJSONLayers`] as Partial<MapboxLayersFixed>[];
